import { Maybe } from "../api/types/generated-types";

const formatterCBM = new Intl.NumberFormat("en-US", { maximumFractionDigits: 3 });
const formatterWeight = new Intl.NumberFormat("en-US", { maximumFractionDigits: 3 });
const formatterLength = new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 });

export const formatCBM = (cbm: Maybe<number> | undefined): string => {
  return `${formatterCBM.format(cbm ?? 0)} cbm`;
};
export const formatWeight = (weight: Maybe<number> | undefined, unit = "kg"): string => {
  return `${formatterWeight.format(weight ?? 0)} ${unit.toLowerCase()}`;
};

export const formatLength = (length: Maybe<number> | undefined, unit = "ft"): string => {
  return `${formatterLength.format(length ?? 0)} ${unit.toLowerCase()}`;
};
